import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import "../../styles/pages-styles/landing-layout-pages-styles/LandingHomePage.css";
import LandingPageFooter from "../../components/landing-page-components/LandingPageFooter";
import LandingPageCard from "../../components/landing-page-components/LandingPageCard";

const LandingHomePage = () => {
  return (
    <div className="landing-homepage">
      <div className="landing-hero">
        <div className="landing-herocard">
          <h1>Advance to the next step</h1>
          <p>
            PassMedicine is a proven revision resource that helps you pass
            high-stakes medical exams
          </p>
          <div className="landing-herobtns">
            <Button variant="primary">
              <a id="bluebtn" href="#features">
                Find out more
              </a>
            </Button>

            <Button variant="secondary">
              <a id="bluebtn" href="/signup">
                Sign up 
              </a>
            </Button>

            {/* <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">

                Sign up
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">MRCP Part 1</Dropdown.Item>
                <Dropdown.Item href="#/action-2">
                  MRCP Part 2 Written
                </Dropdown.Item>
                <Dropdown.Item href="#">
                  MRCGP Applied Knowledge Test
                </Dropdown.Item>
                <Dropdown.Item href="#">
                  Medical student finals / UKMLA resource
                </Dropdown.Item>
                <Dropdown.Item href="#">
                  2025 Multi-Specialty Recruitment Assessment (MSRA)
                </Dropdown.Item>
                <Dropdown.Item href="#">DRCOG</Dropdown.Item>
                <Dropdown.Item href="#">
                  Medical student years 1-3
                </Dropdown.Item>
                <Dropdown.Item href="#">2025 UCAT</Dropdown.Item>
                <Dropdown.Item href="#">USMLE Step 1</Dropdown.Item>
                <Dropdown.Item href="#">PLAB Part 1 & 2 resource</Dropdown.Item>
                <Dropdown.Item href="#">
                  Pharmacy Registration Assessment
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
          </div>
        </div>
      </div>

      <div className="landing-cardcomponent">
        <LandingPageCard />
        <LandingPageCard />
        <LandingPageCard />
        <LandingPageCard />
        <LandingPageCard />
        <LandingPageCard />
        <LandingPageCard />
        <LandingPageCard />
        <LandingPageCard />
      </div>
      <div className="features">
        <div className="features-component">
          <div className="features-component-text">
            <h1>Am I on track to pass? How do I compare to others?</h1>
            <p>
              PassMedicine constructs a histogram based on other candidates
              scores which is updated on a daily basis. This not only allows you
              to see where you are in the pecking order but also helps predict
              whether you're ready to take the exam.
            </p>
          </div>
          <img src="https://placehold.co/600x400" alt="placeholder" />
        </div>

        <div className="features-component">
          <img src="https://placehold.co/600x400" alt="placeholder" />
          <div className="features-component-text">
            <h1>All the features you'd expect. And more.</h1>
            <p>
              Revision mode, timed tests, extensive performance analysis and
              powerful question review functions. Not only are PassMedicine
              questions accompanied by answers there are also revision notes
              under each question. Flag questions, add your own revision notes
              and much more...
            </p>
          </div>
        </div>

        <div className="features-component">
          <div className="features-component-text">
            <h1>
              Introducing the knowledge tutor. Harness the power of spaced
              repetition learning.
            </h1>
            <p>
              As well as our established, conventional question banks
              PassMedicine has developed the knowledge tutor. We've taken the
              results of the latest trials in memory science and applied them to
              medical revision. What this means in practice is a powerful system
              that drills key, high-yield, exam-relevant facts into you.
            </p>
          </div>
          <img src="https://placehold.co/600x400" alt="placeholder" />
        </div>
      </div>
      <LandingPageFooter />
    </div>
  );
};

export default LandingHomePage;
